const INLINE_SCRIPT_REGEX = /(<script([\s\S]*?)(src="?(.*?)"?)*?>)([\s\S]*?)(<\/script>)/gm;
const FIRST_MATCH_INLINE_SCRIPT_REGEX = /(<script([\s\S]*?)(src="?(.*?)"?)*?>)([\s\S]*?)(<\/script>)/m;
const SCRIPT_SRC_INDEX_IN_ARRAY = 3;
const INLINE_SCRIPT_CODE_INDEX_IN_ARRAY = 4;

export {
  INLINE_SCRIPT_REGEX,
  SCRIPT_SRC_INDEX_IN_ARRAY,
  INLINE_SCRIPT_CODE_INDEX_IN_ARRAY,
  FIRST_MATCH_INLINE_SCRIPT_REGEX,
}
